<template>
  <div>
    <v-layout wrap>
      <v-flex xs8 sm4 md3>
        <v-select :items="genderGroup" clearable label="Gender" v-model="filter.genderGroup" @change="onStatusChange" item-text="text" item-value="value" chips attach solo dense></v-select>
      </v-flex>
      <v-flex xs8 sm4 md3 class="ml-2">
        <v-select :items="customerGroup" clearable label="Group" v-model="filter.customerGroup" @change="onStatusChange" chips attach solo dense></v-select>
      </v-flex>
    </v-layout>

    <v-data-table
      :mobile-breakpoint="0"
      :headers="headers"
      :items="notificationList"
      class="elevation-1"
      :items-per-page="25"
      :options.sync="options"
      :loading="loading"
      :server-items-length="totalItemsCount"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template v-slot:item.createdDate="{ item }">
        {{ new Date(parseInt(item.createdDate)) | moment("MMM DD YYYY") }}
      </template>
      <template v-slot:item.createTime="{ item }">
        {{ new Date(parseInt(item.createdDate)) | moment("hh:mm:A") }}
      </template>
      <template v-slot:item.sendBy="{ item }">
        <span v-if="item.sendBy">
          {{ item.sendBy.firstnameEn[0].toUpperCase() + item.sendBy.firstnameEn.substring(1) }}
          {{ item.sendBy.lastnameEn[0].toUpperCase() + item.sendBy.lastnameEn.substring(1) }}
        </span>
        <span v-else>--</span>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  apollo: {
    getAllNotifications() {
      return {
        query: require("../api/getAllNotifications.graphql"),
        variables: this.variables,
        result({ data, loading }) {
          this.loading = loading;
          this.notificationList = data.getAllNotifications.notifications;
          this.totalItemsCount = data.getAllNotifications.totalCount;
        },
      };
    },
  },
  mounted() {
    this.$root.$on("updateNotifications", () => {
      this.loading = true;
      this.$apollo.queries.getAllNotifications.refetch({
        variables: this.variables,
      });
    });
  },
  watch: {
    options: {
      handler() {
        this.variables.limit = this.options.itemsPerPage;
        this.variables.skip = this.options.page * this.options.itemsPerPage - this.options.itemsPerPage;
        this.$apollo.queries.getAllNotifications.refetch({
          limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 500,
          skip: this.variables.skip,
        });
      },
      deep: true,
    },

    filter: {
      handler() {
        this.$apollo.queries.getAllNotifications.refetch({
          limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 500,
          skip: 0,
          filter: {
            customerGroup: this.filter.customerGroup,
            genderGroup: this.filter.genderGroup,
          },
        });
      },
      deep: true,
    },
  },
  data: () => ({
    dialog: false,
    notificationList: [],
    totalItemsCount: 25,
    filter: {
      customerGroup: "",
      genderGroup: "",
    },
    genderGroup: [
      { text: "All", value: "All" },
      { text: "Male", value: "Male" },
      { text: "Female", value: "Female" },
    ],
    customerGroup: [
      { text: "With Current Plan", value: "WITH_CURRENT_PLAN" },
      { text: "With Expired Plan", value: "WITH_EXPIRED_PLAN" },
      { text: "Without Plan", value: "WITHOUT_A_PLAN" },
    ],
    options: {
      itemsPerPage: 25,
      page: 1,
    },
    variables: {
      limit: 25,
      skip: 0,
    },

    loading: true,
    headers: [
      {
        text: "Title",
        value: "title",
        width: 150,
        sortable: false,
      },
      { text: "Send By", value: "sendBy", width: 100, sortable: false },
      { text: "Description", value: "description", width: 300, sortable: false },
      { text: "Type", value: "reciverType", width: 80, sortable: false },
      { text: "Group", value: "customerGroup", width: 80, sortable: false },
      { text: "Date", value: "createdDate", width: 120, sortable: false },
      { text: "Time", value: "createTime", width: 120, sortable: false },
    ],
  }),

  methods: {},
};
</script>
